import React, { useState, useRef } from 'react';
import { Formik } from 'formik';

import makeFullName from 'common/util/makeFullName';
import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import { UTILITY_ACTIVATION_ITEM_ORDER_TYPE_NON_DELAYED_ORDERS } from 'common/utility/constants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';
import SrDarkModal from 'client/components/SrDarkModal';
import SrFrontConversationView from 'client/components/SrFrontConversationView';
import SrFrontConversationForm from 'client/components/SrFrontConversationForm';

import './UPOrdersHitlistTable.less';

const getFormFields = ({ formValues = {}, orderType, utilityDelayedReasons }) => {
  return [
    {
      id: 'utilityDelayedReasonId',
      type: 'select',
      properties: {
        placeholder: 'Reason',
        noMargin: true,
        enableResetOption: true,
        transformToNumber: true,
        choices: utilityDelayedReasons.map((utilityDelayedReason) => ({
          value: utilityDelayedReason.id,
          label: utilityDelayedReason.reason,
        })),
      },
      validations:
        orderType === UTILITY_ACTIVATION_ITEM_ORDER_TYPE_NON_DELAYED_ORDERS ? ['required'] : [],
    },
    {
      id: 'note',
      type: 'long_text',
      properties: {
        placeholder: 'Note',
        style: {
          height: '90px',
        },
      },
      validations: formValues.utilityDelayedReasonId ? ['required'] : [],
    },
  ];
};

const UPOrdersHitlistTableRowDelayOrder = ({
  dispatch,
  currentUser,
  orderType,
  utilityActivation,
  utilityActivationItem,
  utilityDelayedReasons,
  onUpdateUtilityDelayedReason,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formFields = getFormFields({
    orderType,
    utilityDelayedReasons,
  });
  const frontConversationViewRef = useRef(null);

  return (
    <div styleName="delayOrderBox">
      <SrButton
        theme={SR_BUTTON_THEME_ADOBE_GREY}
        width="326px"
        margin="0 0 14px"
        hasBoxShadow
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        Delay Order
      </SrButton>

      {isModalOpen && (
        <SrDarkModal
          onClose={() => {
            setIsModalOpen(false);
          }}
        >
          <div
            onClick={preventDefaultPropagation}
            className="adminDefaultModal SrFrontConversationModal"
          >
            <SrText align="center" display="block" weight="600" paddingTop="10px">
              Front Conversation
            </SrText>
            <div styleName="frontConversationListView">
              {utilityActivation.utilityFrontConversationId && (
                <SrFrontConversationView
                  ref={frontConversationViewRef}
                  user={{
                    name: makeFullName(
                      utilityActivation.user.firstName,
                      utilityActivation.user.lastName,
                    ),
                  }}
                  frontConversationId={utilityActivation.utilityFrontConversationId}
                  dispatch={dispatch}
                />
              )}
              {utilityActivation.utilityFrontConversationId && (
                <SrFrontConversationForm
                  frontConversationId={utilityActivation.utilityFrontConversationId}
                  user={{
                    phone: utilityActivation.user.phone,
                  }}
                  dispatch={dispatch}
                  onMessageSent={(newFrontMessage) => {
                    frontConversationViewRef.current.addMessage(newFrontMessage);
                  }}
                  currentUser={currentUser}
                />
              )}
            </div>
            <Formik
              initialValues={{
                utilityDelayedReasonId: utilityActivationItem?.utilityDelayedReasonId,
              }}
              validate={(formValues) => {
                const formFields = getFormFields({
                  formValues,
                  orderType,
                  utilityDelayedReasons,
                });
                return createFormValidationFn(formFields)(formValues);
              }}
              onSubmit={onUpdateUtilityDelayedReason}
            >
              {(formikBag) => {
                return (
                  <SrBox padding="0px 20px 20px">
                    <SrText align="center" display="block" weight="600">
                      Delay Order
                    </SrText>
                    {formFields.map((formField) => (
                      <SrFormikField
                        key={formField.id}
                        formField={formField}
                        formikBag={formikBag}
                        className={SR_FIELD_THEME_ADOBE}
                      />
                    ))}
                    <SrButton
                      theme={SR_BUTTON_THEME_ADOBE_YELLOW}
                      margin="10px 0 0"
                      hasBoxShadow
                      onClick={formikBag.handleSubmit}
                    >
                      Submit
                    </SrButton>
                  </SrBox>
                );
              }}
            </Formik>
          </div>
        </SrDarkModal>
      )}
    </div>
  );
};

export default UPOrdersHitlistTableRowDelayOrder;
